"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMobileDeviceType = exports.DeviceType = void 0;
const web_env_1 = require("@snapchat/web-env");
var DeviceType;
(function (DeviceType) {
    DeviceType["DESKTOP"] = "desktop";
    DeviceType["ANDROID"] = "android";
    DeviceType["iOS"] = "ios";
    DeviceType["UNKNOWN"] = "unknown";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
// Detect device type on mobile
function getMobileDeviceType() {
    // eslint-disable-next-line no-restricted-globals -- Fix this the next time you touch this code
    const userAgent = (0, web_env_1.getNavigator)()?.userAgent || (0, web_env_1.getNavigator)()?.vendor || "";
    if (/android/i.test(userAgent)) {
        return DeviceType.ANDROID;
    }
    // MSStream is present only on Windows Phone 8.1 IE11, which pretends to be an iPhone
    // eslint-disable-next-line no-restricted-globals
    if (/iPad|iPhone|iPod/.test(userAgent) && !("MSStream" in window)) {
        return DeviceType.iOS;
    }
    return DeviceType.UNKNOWN;
}
exports.getMobileDeviceType = getMobileDeviceType;
//# sourceMappingURL=device-detection.js.map